import CustomBarChart from './barChart'
export default CustomBarChart
